import { createStyles, makeStyles } from '@material-ui/styles';
import GoldTexture from 'assets/avatar/categories/gold-texture.jpg';
import HalloweenTexture from 'assets/avatar/categories/halloween-texture.png';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      margin: '0',
      padding: '5px 10px',
      border: '2px solid transparent',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      alignItems: 'center',
      color: palette.common.white,
      background: '#50A342',
      borderRadius: palette.borderRadius.default,
      fontWeight: 700,
      fontSize: '1.5rem',
      '&>img': {
        width: '36px',
        height: '36px'
      },
      '@media (max-width: 350px)': {
        flexDirection: 'column',
        gap: '0'
      },
      '@media (max-width: 425px)': {
        padding: '3px 3px'
      }
    },
    bronze: {
      textShadow: palette.shadows.textShadow,
      border: '2px solid #E4912F',
      background:
        'linear-gradient(90.43deg, #A65A00 0%, #E4912F 75%, #AE6611 100%)',
      '&>img': {
        mixBlendMode: 'luminosity'
      }
    },
    silver: {
      textShadow: palette.shadows.textShadow,
      border: '2px solid #A9A7A7',
      background:
        'linear-gradient(90.43deg, #7D7D7D 0%, #BAB8B8 75%, #7D7D7D 100%)',
      '&>img': {
        mixBlendMode: 'luminosity'
      }
    },
    gold: {
      textShadow: palette.shadows.textShadow,
      border: '2px solid #FFC90A',
      background: `linear-gradient(90deg, rgba(255, 201, 10, 0.7) 0%, rgba(255, 245, 10, 0.7) 75%, rgba(255, 201, 10, 0.7) 100%), url(${GoldTexture})`,
      backgroundSize: 'cover'
    },
    halloween: {
      textShadow: palette.shadows.textShadow,
      border: '2px solid ##551A8BB3',
      background: `linear-gradient(90deg, rgba(85, 26, 139, 0.7) 0%, rgba(139, 0, 139, 0.7) 75%, rgba(85, 26, 139, 0.7) 100%), url(${HalloweenTexture})`,
      backgroundSize: 'cover'
    },
    text: {
      margin: '0'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
